// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.move-down-dialog[data-v-59bc0840] {\n  margin-top: 20vh; /* 使用vh单位移动20个视窗高度 */\n}\ni[data-v-59bc0840]{\n  margin-right: 8px;\n  color: orange;\n  font-size: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
